import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()((theme) => ({
  chip: {
    borderRadius: '999px',
    padding: '4px 8px',
    backgroundColor: 'var(--muted)',
  },
  chipText: {
    fontWeight: 400,
    fontSize: '12px',
    lineHeight: '16px',
    letterSpacing: '0px',
  },
  walletChip: {
    background: 'color-mix(in srgb, #0B79D0 15%, var(--background))',
  },
  walletChipText: {
    color: '#0B79D0',
  },
  exchangeChip: {
    backgroundColor: 'color-mix(in srgb, #943E1B 15%, var(--background))',
  },
  exchangeChipText: {
    color: '#C25A2E',
  },
  devtoolChip: {
    backgroundColor: 'var(--muted)',
  },
  devtoolChipText: {
    color: 'var(--muted-foreground)',
  },
  stableCoinChip: {
    backgroundColor: 'color-mix(in srgb, #DC3BB4 15%, var(--background))',
  },
  stableCoinChipText: {
    color: '#DC3BB4',
  },
  validatorChip: {
    backgroundColor: 'color-mix(in srgb, #CB0808 15%, var(--background))',
  },
  validatorChipText: {
    color: '#CB0808',
  },
  nftChip: {
    backgroundColor: 'color-mix(in srgb, #C77700 15%, var(--background))',
  },
  nftChipText: {
    color: '#C77700',
  },
  businessChip: {
    backgroundColor: 'color-mix(in srgb, #4444FF 15%, var(--background))',
  },
  businessChipText: {
    color: '#6666FF',
  },
  web3BrowserChip: {
    backgroundColor: 'color-mix(in srgb, #AA00BB 15%, var(--background))',
  },
  web3BrowserChipText: {
    color: '#CC44DD',
  },
}));

export { useStyles };
